<script>
import ZapierService from "../services/ZapierService";
import AuthShell from "../components/auth/auth-shell.vue";

export default {
  components: {
    AuthShell,
  },
  data() {
    return {
      username: "",
      password: "",
      working: false,
      rememberMe: false,
    };
  },
  mounted() {
    let self = this;

    var rememberMeUser = $A.CheckRememberMe();
    if (rememberMeUser) {
      this.rememberMe = true;
      this.username = rememberMeUser;
    }
    if (
      this.$route.query.state !== undefined &&
      this.$route.query.redirect_uri !== undefined
    ) {
      //wait for loging auth.
    } else {
      $A.NavigateToView("/403");
      return;
    }
    this.$root.$on("alert::user", (message, type, timeout) =>
      // self.AlertUser(message, type)
        self.$A.AlertUser(message, type, timeout)
    );
  },
  methods: {
    async Authorize() {
      if (this.working) {
        return;
      }
      let c = this;
      if (this.rememberMe) {
        $A.SetRememberMe(this.username);
      }
      this.working = true;
      let authResponse = await $A.ZapierService.AuthorizeAccess(
        this.username,
        this.password,
        this.$route.query.redirect_uri,
        this.$route.query.state
      );
      if (authResponse.data.success) {
        this.$A.AlertUser(
          "You have successfully authorized Zapier, Please Wait To Be Redirected Back To Zapier",
          "success"
        );
        setTimeout(function () {
          console.log(
            "redirecting back to zapier",
            c.$route.query.redirect_uri +
              "?code=" +
              authResponse.data.authApprovalCode +
              "&state=" +
              c.$route.query.state
          );
          document.location.href =
            c.$route.query.redirect_uri +
            "?code=" +
            authResponse.data.authApprovalCode +
            "&state=" +
            c.$route.query.state;
        }, 5000);
      } else if (
        authResponse.data.message !== undefined &&
        authResponse.data.message === "Invalid Credentials"
      ) {
        this.$A.AlertUser("Your username or password is incorrect.");
      } else {
        this.$A.AlertUser("There was an issue that was encountered if you cannot get past this point please contact support.");
      }
      this.working = false;
    },
  },
};
</script>

<style scoped>
.zapier-connection {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 14px;
  margin-bottom: 20px;
}

.zapier-connection img {
  height: 44px;
}

.zapier-logo {
  border-radius: 999px;
  overflow: hidden;
  width: 44px;
  height: 44px;
  background: url("/img/zapier/zapier.png");
  background-size: contain;
}

.zapier-connection-arrows {
  color: #9ca3af;
  font-size: 16px;
  letter-spacing: 2px;
}
</style>

<template>
  <auth-shell>
    <div class="zapier-connection">
      <img src="/img/logo-large.svg" />
      <span class="zapier-connection-arrows">&harr;</span>
      <div class="zapier-logo" />
    </div>
    <h4 class="auth-title">Zapier Authorization</h4>
    <p class="auth-subtitle">
      To Authorize Zapier To Connect To Your Ashore Account On Your
      Behalf Login With Your Credentials Below:
    </p>
    <div class="form-group">
      <label class="auth-label">Your Email</label>
      <input
        type="text"
        name="Username"
        class="auth-field"
        v-model="username"
      />
    </div>
    <div class="form-group">
      <label class="auth-label">Your Password</label>
      <input
        type="password"
        name="Password"
        class="auth-field"
        v-model="password"
        v-on:keyup.enter="Authorize()"
      />
    </div>
    <button
      v-on:click="Authorize()"
      style="margin-top: 12px"
      class="auth-btn-primary"
    >
      <b-spinner
        variant="light"
        v-show="working"
        type="grow"
        small
      ></b-spinner>
      Login
    </button>
  </auth-shell>
</template>
